export default "__VITE_ASSET__DGWv8QbS__"